import React from "react";

const Image = () => (
  <svg width="65" height="65" viewBox="0 0 65 65">
    <g fill="none" fillRule="evenodd">
      <path
        d="M62 32.5a29.5 29.5 0 1 1-59 0 29.5 29.5 0 0 1 59 0z"
        stroke="#24C991"
        strokeWidth="5"
      />
      <path
        d="M29.2 43c-.5 0-1-.18-1.37-.56l-5.77-5.7a1.88 1.88 0 0 1 0-2.68 1.94 1.94 0 0 1 2.72 0l4.41 4.35 14.03-13.85a1.94 1.94 0 0 1 2.72 0c.75.74.75 1.94 0 2.68l-15.39 15.2c-.37.38-.87.56-1.36.56"
        fill="#0093C4"
      />
    </g>
  </svg>
);
export default Image;
